'use client';

import { Avatar as HeroAvatar } from '@heroui/react';

export interface AvatarProps {
  src?: string;
  alt?: string;
  initials?: string;
  fallback?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Avatar = ({
  src,
  alt,
  initials,
  fallback,
  size = 'md',
}: AvatarProps) => {
  const placeholder = initials || fallback;

  return (
    <HeroAvatar size={size} variant="soft" color="accent">
      {src && <HeroAvatar.Image src={src} alt={alt} />}
      {placeholder && <HeroAvatar.Fallback>{placeholder}</HeroAvatar.Fallback>}
    </HeroAvatar>
  );
};
